import { Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import StandardLinkShorttag from './StandardLinkShorttag.vue';
import RouterLinkSimple from '../RouterLinkSimple.vue';

export default Node.create({
  name: 'StandardLinkShorttag',
  group: 'inline',
  inline: true,
  content: 'text*',
  marks: '_',
  allowGapCursor: false,
  components: {
    ...StandardLinkShorttag.components,
  },
  addAttributes() {
    return {
      ...StandardLinkShorttag.props,
      ...RouterLinkSimple.props,
    };
  },
  parseHTML() {
    return [
      {
        tag: 'standard-link-shorttag',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const targetBlankAttributes = {};
    if (HTMLAttributes.target) {
      targetBlankAttributes.target = '_blank';
      targetBlankAttributes.rel = 'noopener';
    }

    return ['a', {
      href: HTMLAttributes.to,
      title: HTMLAttributes.title,
      ...targetBlankAttributes,
      class: 'link-underline',
    }, 0];
  },
  addNodeView() {
    return VueNodeViewRenderer(StandardLinkShorttag);
  },
});
